/**
 * angular.lowercase / angular.uppercase compatibility shim
 *
 * These utility functions were removed in Angular 1.7.0.
 * textAngular-sanitize.min.js (based on AngularJS 1.3.10) still uses them,
 * so we restore them here after angular itself loads.
 */
if (window.angular) {
  if (!angular.lowercase) {
    angular.lowercase = function(s) { return typeof s === 'string' ? s.toLowerCase() : s; };
  }
  if (!angular.uppercase) {
    angular.uppercase = function(s) { return typeof s === 'string' ? s.toUpperCase() : s; };
  }
}
